import { Typography } from "@mui/material";
import { IWorkInfoTableRow } from "../../components/WorkInfoTable/WorkInfoTableModel";
import { scrollToElement } from "../../utils";
import { IWorkInformationItem, IWorkInformationTotal } from "./WorkInfoData";

export enum Region {
  vancouver = "Vancouver",
  squamish = "Squamish",
  coastwise = "Coastwise",
}

export const REGIONS = Object.values(Region);

export enum Category {
  all = "All",
  trades = "Trades",
  machine = "Machine",
  rail = "Rail",
  warehouse = "Warehouse",
  dock = "Dock",
  wheat = "Wheat",
  checkers = "Checkers",
  firstaid = "First Aid",
  topside = "Topside",
  hold = "Hold",
  gearperson = "Gearperson",
  surplus = "Surplus"
}

export const VANCOUVER_CATEGORIES = Object.values(Category);

export const SQUAMISH_CATEGORIES = [
  Category.all,
  Category.trades,
  Category.topside,
  Category.machine,
  Category.checkers,
  Category.firstaid,
  Category.hold,
  Category.gearperson,
  Category.dock
];

export const COASTWISE_CATEGORIES = [
  Category.all,
  Category.trades,
  Category.topside,
  Category.machine,
  Category.firstaid,
  Category.checkers,
  Category.hold,
]

export const getRows = (
  workInformation: IWorkInformationItem[],
  hasAll: boolean,
  totals: IWorkInformationTotal[]
): {
  headerRows: IWorkInfoTableRow[],
  bodyRows: IWorkInfoTableRow[],
  footerRows: IWorkInfoTableRow[]
} => {
  const headerRows = [
    {
      cells: [
        [{ children: '' }],
        ...workInformation[0].totals.map((total) =>
          ([{ children: total.shift, align: 'center' }, { children: total.date, align: 'center' }]))
      ]
    },
    {
      tableCellHasColumns: true,
      cells: [
        [{ children: 'Job' }],
        ...Array(workInformation[0].totals.length).fill('').map(() =>
          ([{ children: 'Pre', align: 'center' }, { children: 'At', align: 'center' }])),
      ]
    }
  ] as IWorkInfoTableRow[];

  const categoryRows = workInformation[0].jobs.map((item) => ([
    {
      isDisable: !item.sites,
      tableCellHasColumns: true,
      cells: [
        [{ children: item.job }],
        ...Array(workInformation[0].totals.length).fill('').map(item => ([{ children: item }, { children: item }]))
      ]
    },
    (item.sites && item.sites.map((site) => (
      {
        tableCellHasColumns: true,
        isSubCategoryRow: true,
        cells: [
          [{ children: site.name }],
          ...site.dates.map((date) => (
            [{ children: date.pre, align: 'center' }, { children: date.at, align: 'center' }]
          ))
        ]
      }
    ))),
  ]));

  const hasAllRows = workInformation.map((workInfo) => ({
    tableCellHasColumns: true,
    cells: [
      [{
        children: <Typography
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => scrollToElement(`${workInfo.section.replace(/\s+/g, '-')}`, 70)}
        >
          {workInfo.section}
        </Typography>
      }],
      ...workInfo.totals.map(total =>
        ([{ children: total.pre === '0' ? '' : total.pre, align: 'center' }, { children: total.at === '0' ? '' : total.at, align: 'center' }]))
    ]
  }
  ))

  const bodyRows = hasAll ? hasAllRows as IWorkInfoTableRow[] :
    categoryRows.flat(2).filter(item => item) as IWorkInfoTableRow[];

  const footerRowsTotal = hasAll ? totals : workInformation[0].totals;

  const footerRows = [
    {
      tableCellHasColumns: true,
      cells: [
        [{ children: 'Totals' }],
        ...footerRowsTotal.map((total) => (
          [{ children: total.pre, align: 'center' }, { children: total.at, align: 'center' }]
        ))
      ]
    }
  ] as IWorkInfoTableRow[];

  return {
    headerRows,
    bodyRows,
    footerRows
  }
}
